import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

    private triggerPDFExport = new Subject<void>();
    triggerPDFExport$ = this.triggerPDFExport.asObservable();

    triggerPDF(): void {
        this.triggerPDFExport.next();
    }

    /**
     * Télécharge un fichier CSV avec encodage UTF-8 et BOM pour que les caractères accentués (é, è, à, etc.)
     * s'affichent correctement dans Excel au lieu de Ã©, Ã , etc.
     * @param csvContent Contenu CSV (lignes avec virgules, sans préfixe data:...)
     * @param filename Nom du fichier (ex: 'facture.csv')
     */
    downloadCSV(csvContent: string, filename: string): void {
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
}
